module.exports = __webpack_public_path__ + "img/racecourse-vaal-turf-inner-1400.9765c1f9.svg";